<template>
  <div
    v-if="!isOnValidNetwork"
    class="bg-black bg-opacity-40 border-red-800 border-opacity-80 border-2 p-3 text-white rounded-lg flex items-center justify-between"
  >
    <h1 class="px-2 text-xs sm:text-lg pr-5">
      Please connect to a valid network: {{ validNetworkNames }}
    </h1>
    <Button
      text="Change Network"
      small
      danger
      class="max-w-max"
      @click="switchNetwork('eth')"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Button from "../global/Button.vue";
export default {
  name: "NetworkError",
  components: {
    Button,
  },
  computed: {
    ...mapGetters([
      "isOnValidNetwork",
      "isConnected",
      "initLoading",
      "validNetworkNames",
    ]),
    ...mapState({
      networks: ({ main }) => main.networks,
    }),
  },
  methods: {
    ...mapActions(["setSelectedNetwork"]),
    async switchNetwork(value) {
      let network = this.networks.find((n) => n.short_name == value);
      try {
        await this.setSelectedNetwork(network.short_name);

        if (!this.isConnected) {
          return;
        }
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [
            {
              chainId: `0x${network.chain_id.toString(16)}`,
            },
          ],
        });
      } catch (err) {
        if (err.code == 4902) {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: `0x${network.chain_id.toString(16)}`,
                chainName: network.name,
                rpcUrls: [network.rpc_url],
                nativeCurrency: {
                  ...network.native_currency,
                },
              },
            ],
          });
        }
      }
    },
  },
};
</script>
